module.exports = __webpack_public_path__ + "static/media/i_girar.d47ad17d.svg";